import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface ExternalLinkType {
  metaExternalLinkUuid: string;
  name: string;
  logo: string;
  isOther: boolean;
}

const externalLinksApi = createApi({
  reducerPath: "externalLinksApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${JSON.parse(token)}`);
      }
      headers.set("bludot-app-name", "business-rewards");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    externalLinkTypes: builder.query<ExternalLinkType[], void>({
      query: () => ({
        url: `${process.env.REACT_APP_SERVER_URL_V1}/external-links`,
        method: "GET",
      }),
    }),
  }),
});

export const { useExternalLinkTypesQuery, useLazyExternalLinkTypesQuery } = externalLinksApi;
export default externalLinksApi;
